module.exports = __webpack_public_path__ + "public/media/urban-leads.png";


//////////////////
// WEBPACK FOOTER
// ./images/partners/urban-leads.png
// module id = ./images/partners/urban-leads.png
// module chunks = 0